export const INTERRUPT_KEYWORDS = [
  'stop',
  'cancel',
  'hold on',
  'wait',
  'wait a second',
  'wait a moment',
  'one sec',
  'just a sec',
  'pause',
  'stop talking',
  'hang on',
  'excuse me',
  'sorry',
  'sorry to interrupt',
  'interrupt',
  'listen',
  'no',
  "that's enough",
  'that is enough',
  'enough',
  'stop now',
  'please stop',
  'i have a question',
  'i need to say',
  'hold up',
  'so',
  // Urdu script — the recogniser now runs in the user's own language, so barge-in has to be
  // recognisable in it too, not just in English.
  'رکو',
  'رکیں',
  'ٹھہرو',
  'ٹھہریں',
  'بس',
  'بند کرو',
  'بند کریں',
  'ایک منٹ',
  'ایک سیکنڈ',
  'معاف کریں',
  'سنیں',
  'سنو',
  'نہیں',
  'میرا ایک سوال ہے',
  // Roman Urdu — what the engine emits when it is running in English on Urdu speech, and what
  // users type-think in when code-switching.
  'ruko',
  'rukein',
  'rukiye',
  'thehro',
  'theharo',
  'bas karo',
  'band karo',
  'band karen',
  'ek minute',
  'ek second',
  'suniye',
  'nahi',
]

// `\b` in JavaScript is defined over [A-Za-z0-9_], so an Urdu-script keyword wrapped in word
// boundaries can never match. Latin keywords still need the boundaries — without them 'so' fires on
// 'also' and 'no' on 'know'.
const isLatinKeyword = (keyword: string) => /^[\x20-\x7e]+$/.test(keyword)

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Finds the interrupt keyword the user spoke, or undefined when they said none.
 *
 * @param text - Recognised speech, final or interim.
 * @returns The matched keyword, for logging and callbacks.
 */
export const findInterruptKeyword = (text: string): string | undefined => {
  if (!text) return undefined
  const haystack = text.toLowerCase()
  return INTERRUPT_KEYWORDS.find((keyword) => {
    if (!isLatinKeyword(keyword)) return haystack.includes(keyword)
    return new RegExp(`\\b${escapeRegExp(keyword)}\\b`, 'i').test(haystack)
  })
}

export const detectCallSupport = () =>
  typeof window !== 'undefined' &&
  typeof navigator !== 'undefined' &&
  !!navigator.mediaDevices?.getUserMedia


export const generateTranscriptId = (speaker: 'user' | 'ai') => {
  return `${speaker}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

export const decodeHeader = (val?: string) => {
  try {
    return val ? decodeURIComponent(val) : ''
  } catch {
    return val || ''
  }
}

export const mapWordsToTimestamps = (text: string, durationSec: number) => {
  const words = text.trim().split(/\s+/)
  const lengths = words.map((w) => w.length)
  const total = lengths.reduce((a, b) => a + b, 0) || 1
  let cum = 0
  return words.map((w, i) => {
    cum += lengths[i]
    return {word: w, time: (cum / total) * durationSec}
  })
}
